import { FC } from "react";
import { Outlet } from "react-router-dom";

import { HeaderComponent } from "../../components/header.component.tsx";
import { Footer } from "../../components/footer.tsx";

export const Layout: FC = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden">
      <HeaderComponent />
      <div className="flex-grow">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};
